import type { FC } from "react";

import { StoreLocatorLayoutSwitcher } from "@locators/components/shared/components/StoreLocatorLayoutSwitcher";
import classNames from "classnames";

import { FilterIcon } from "@jti/brand-icons/filter";
import { NewFilterIcon } from "@jti/brand-icons/new-filter";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./StoreLocatorFilterButton.module.scss";

type StoreLocatorFilterButtonProps = {
  onToggleFilters: () => void;
  isFiltersOpened: boolean;
  isFiltersAvailable: boolean;
  selectedFiltersNumber: number;
  className?: string;
};
export const StoreLocatorFilterButton: FC<StoreLocatorFilterButtonProps> = ({
  onToggleFilters,
  isFiltersOpened,
  isFiltersAvailable,
  selectedFiltersNumber,
  className,
}) => {
  const { __ } = useTranslations();
  if (!isFiltersAvailable) {
    return null;
  }
  return (
    <button
      data-testid="storeLocatorFilterButton"
      className={classNames(styles.filtersButton, className, {
        [styles.filtersButtonActive]: isFiltersOpened,
        [styles.filtersButtonFilled]: selectedFiltersNumber,
      })}
      onClick={onToggleFilters}
    >
      <StoreLocatorLayoutSwitcher layout="v1">
        <FilterIcon className={styles.filterIcon} />
        {__("storelocator.filters")} {selectedFiltersNumber ? `(${selectedFiltersNumber})` : null}
      </StoreLocatorLayoutSwitcher>
      <StoreLocatorLayoutSwitcher layout="v2">
        <NewFilterIcon className={styles.filterIcon} />
        {selectedFiltersNumber > 0 && <div className={styles.filtersButtonNumber}>{selectedFiltersNumber}</div>}
      </StoreLocatorLayoutSwitcher>
    </button>
  );
};
